import React from "react";
import { Route } from "react-router-dom";
import { connect } from "react-redux";
import { setFiltersAction } from "../../services/filters/actions";
import { buildContentAction } from "../../services/content/actions";

import Filters from "./Filters";
import ProductGrid from "./ProductGrid";
import ProductDetail from "./ProductDetail";
import MetaDetail from "../../components/_common/MetaDetail";

import buildBeersJson from "./build-beer-json";

import "./scss/beers.scss";

const mapStateToProps = state => ({ filtersData: state.filters });

class TheBeersPage extends React.Component {
	comingSoonIndex = 3;

	state = { filterNames: [] };

	setFilterNames = filterNames => {
		this.setState({ filterNames });
	};

	moduleNames = [
		{ name: "Beer category", title: "Category" },
		{ name: "Beer tags", title: "Tags" },
		{ name: "Beer header (name and image)", title: "Header" },
		{ name: "Beer characteristics", title: "Characteristics" },
		{ name: "Malts and Hops", title: "MaltsHops" },
		{ name: "Beer description", title: "Description" },
		{ name: "Exclusive module", title: "Exclusive" }
	];

	componentDidMount() {
		if (!this.props.data || !this.props.data.fetchedData) {
			this.props.fetchData(
				{
					name: "theBeersPage",
					modules: this.moduleNames,
					transform: true,
					buildJson: buildBeersJson
				},
				true,
				"Beer Product Page"
			);
		} else if (!this.props.data.built && this.props.data.data) {
			this.props.buildContentAction(this.props.data.data, {
				name: "theBeersPage",
				modules: this.moduleNames,
				transform: true,
				buildJson: buildBeersJson
			});
		} else {
			console.log("TheBeersPage - data fetched");
		}
	};

		render() {
		const { filtersData, componentData, fetchData } = this.props;
		const { filterNames } = this.state;
		const meta = {
			title: 'The Beers',
			description: 'Featured beers',
			canonical: window.location.href
		}

		if (!this.props.data || !this.props.data.contents) {
			return null;
		};

		return (
			<div>
				<Route
					exact
					path="/the-beers"
					render={props => (
						<div className="beers">
							<MetaDetail meta={meta} />
							<h1 className="beers__headline">The beers</h1>
							<ProductGrid products={this.props.data.contents} />
							<div className="cta-container list-group__container">
								<div className='cta-container__content-wrap'>
									<div className='cta-container__content'>
										<div className='cta-container__copy'>Our taproom is the centre of experimentation, once a beer is brewed in the experimental brewery, we take it to the taproom; where the beer we dreamed up become a reality and people from all over the  world come to taste unique experimental beers crafted by our brewers and our guest tap collaborators. Keep an eye on what’s brewing and stay up to date with what's on tap.</div>
										<a className='cta-container__link-wrap' href="https://twitter.com/opengatebrewery?lang=en"><div className='cta-container__cta'><span>Follow Us On Twitter</span></div></a>
									</div>
								</div>
							</div>
						</div>
					)}
				/>
			</div>
		);
	}
}

export default connect(
	mapStateToProps,
	{ setFiltersAction, buildContentAction }
)(TheBeersPage);



// WEBPACK FOOTER //
// ./src/pages/beers/index.js